import React from "react";
import { getActiveReservations } from "../../actions";
import Reservations from "./reservations";

const ActiveReservations = ({ location, history, match }) => {
	const id = match.params.id || null;
	return <Reservations reservationsLoader={getActiveReservations} id={id} />;
};

export default ActiveReservations;
